"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _dicts = require("@package/dicts");

var _react = _interopRequireDefault(require("react"));

var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["status", "type"];
var INVOICE_HELD_STATUS_CODE = 10;

var Factory = function Factory(_ref) {
  var _ref$status = _ref.status,
      status = _ref$status === void 0 ? 0 : _ref$status,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    if ([1].indexOf(status) > -1) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": props['data-locator'],
        type: type,
        mode: "default"
      }, _dicts.PAYOUT_STATUS[status]);
    } else if ([4, 8].indexOf(status) > -1) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['wrapper']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": props['data-locator'],
        type: type,
        mode: "danger"
      }, _dicts.PAYOUT_STATUS[status]), /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
        transactions: props['transactions'],
        "data-locator": props['data-locator']
      }));
    } else if ([INVOICE_HELD_STATUS_CODE].indexOf(status) > -1) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": props['data-locator'],
        type: type,
        mode: "info"
      }, _dicts.PAYOUT_STATUS[status]);
    } else if ([3, 9].indexOf(status) > -1) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": props['data-locator'],
        type: type,
        mode: "success"
      }, _dicts.PAYOUT_STATUS[status]);
    } else if ([6, 104].indexOf(status) > -1) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": props['data-locator'],
        type: type,
        mode: "primary"
      }, _dicts.PAYOUT_STATUS[status]);
    }

    return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
      "data-locator": props['data-locator'],
      type: type,
      mode: "default"
    }, _dicts.PAYOUT_STATUS[status]);
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
};

var _default = /*#__PURE__*/_react["default"].memo(Factory);

exports["default"] = _default;